// js
import React from 'react';
import PropTypes from 'prop-types';
import SecurityDetail from '../../containers/analytics/SecurityDetail';

const SecurityNonCriticalInadequateDetail = ({ data }) => {
  return (
    <SecurityDetail
      data={data}
      criticality='nonCritical'
      adequacy='inadequate'
    />
  );
};

SecurityNonCriticalInadequateDetail.propTypes = {
  data: PropTypes.object.isRequired
};

export default SecurityNonCriticalInadequateDetail;



// WEBPACK FOOTER //
// ./src/components/analytics/SecurityNonCriticalInadequateDetail.js